import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center ga-4" }
const _hoisted_2 = {
  key: 1,
  class: "d-flex align-center justify-space-between"
}
const _hoisted_3 = { class: "d-flex align-center ga-3" }

import {computed} from 'vue';
import Icon from "@/components/Icons/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShopCartOrderShippingMethod',
  props: {
  item: {
    type: Object,
  },
  userStore: {
    type: Object,
  },
  disabled: {
    type: Boolean,
    default: false
  },
},
  emits: ['delete', 'addShipping'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const getShipping = computed(() => {
  return props.item.items.find(i => i.product.type == 'shipping_method') ?? null;
})

const getSupplierName = computed(() => {
  if (props.item.supplier) {
    return props.item?.supplier?.name ?? null;
  }
  return props.userStore.user?.clinic.name ?? null;
})

return (_ctx: any,_cache: any) => {
  return (getShipping.value === null)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "d-flex align-center ga-3",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('addShipping', __props.item.id)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(Icon, { icon: "plus-icon" }),
          (getSupplierName.value)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: _normalizeClass([{'secondary-background-button-color': !__props.item?.supplier }, "font-size-10-600 supplier font-grey-dark"])
              }, _toDisplayString(getSupplierName.value), 3))
            : _createCommentVNode("", true)
        ])
      ]))
    : (getShipping.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Icon, { icon: "shipping-icon" }),
            _createElementVNode("p", null, _toDisplayString(getShipping.value?.product?.name), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([{'disabled': __props.disabled}, "text-right font-size-16-600 pt-0"]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('delete', getShipping.value.cart_id, getShipping.value.id)))
          }, [
            _createElementVNode("p", null, [
              _createVNode(Icon, { icon: "trash-icon" })
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true)
}
}

})